/* esm.sh - applesauce-core@5.2.0/dist/operations/event */
export * from "/*applesauce-core@5.2.0/esnext/dist/operations/event.mjs";
